import logUtil from 'utils/log'
import setItemLocalStorageUtil from 'utils/local-storage/set-item'
import { CART_LOCAL_STORAGE_KEY } from 'modules/cart/constants'
import removeItemLocalStorageUtil from 'utils/local-storage/remove-item'
import getItemLocalStorageUtil from 'utils/local-storage/get-item'

export const getSpendMoreToUnlockExtraFreeSamplesModalAt = () => {
  logUtil('getSpendMoreToUnlockExtraFreeSamplesModalAt').info('[done]')
  return getItemLocalStorageUtil(CART_LOCAL_STORAGE_KEY.SPEND_MORE_TO_UNLOCK_EXTRA_FREE_SAMPLES_MODAL_SHOWN_AT)
}

export const updateSpendMoreToUnlockExtraFreeSamplesModalAt = (value) => {
  logUtil('updateSpendMoreToUnlockExtraFreeSamplesModalAt').info('value=', value)
  setItemLocalStorageUtil(CART_LOCAL_STORAGE_KEY.SPEND_MORE_TO_UNLOCK_EXTRA_FREE_SAMPLES_MODAL_SHOWN_AT, value)
}

export const removeSpendMoreToUnlockExtraFreeSamplesModalAt = () => {
  logUtil('removeSpendMoreToUnlockExtraFreeSamplesModalAt').info('[done]')
  removeItemLocalStorageUtil(CART_LOCAL_STORAGE_KEY.SPEND_MORE_TO_UNLOCK_EXTRA_FREE_SAMPLES_MODAL_SHOWN_AT)
}
